import { render, staticRenderFns } from "./FormImppv.vue?vue&type=template&id=f8c03544&"
import script from "./FormImppv.vue?vue&type=script&lang=ts&"
export * from "./FormImppv.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports